module.exports = __webpack_public_path__ + "static/media/login-decoration-end.afd8db87.svg";